import { render, staticRenderFns } from "./DeptTree.vue?vue&type=template&id=3b3685f0&"
import script from "./DeptTree.vue?vue&type=script&lang=js&"
export * from "./DeptTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports